
import React from 'react';
import { cn } from '@/lib/utils';

interface IntellendLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const IntellendLogo: React.FC<IntellendLogoProps> = ({ className, size = 'md' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-14',
  };

  return (
    <div className={cn('flex items-center', className)}>
      <img 
        // src="/lovable-uploads/2c72f7f5-8104-48d4-b42b-283c87f2d696.png"
        src="/logo.svg"
        alt="Intellend Logo"
        className={cn(sizeClasses[size])}
      />
    </div>
  );
};

export default IntellendLogo;
